import { useAxios } from "@hooks";
import { useQuery } from "@tanstack/react-query";
import { PendingCorrection } from "../../types/grading";
import { GradingStatusEnum } from "../../types/grading/GradingStatus";

/**
 * Hook for fetching pending corrections for the assessor queue.
 * @param status Optional filter by grading status
 * @param options Query options
 */
export const useGetPendingCorrections = (
  status?: GradingStatusEnum,
  options?: { enabled?: boolean }
) => {
  const axios = useAxios();

  return useQuery<PendingCorrection[]>({
    queryKey: ["pendingCorrections", status],
    queryFn: async () => {
      const response = await axios.get<PendingCorrection[]>(
        "/api/grading/pending-corrections",
        {
          params: { status },
        }
      );
      return response.data;
    },
    enabled: options?.enabled !== false,
    refetchOnWindowFocus: true,
    // Poll every minute to check for new submissions or lock releases
    refetchInterval: 60000, 
  });
};

export default useGetPendingCorrections;
